import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.quiz.play');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-quiz-play',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.quiz.play/view.scss */
:host {
  display: block;
  height: 100%;
}

.exam-page-image {
  width: 100%;
  border-radius: 0.5rem;
  background-color: #f9fafb;
  min-height: 200px;
}`],
})
export class PageQuizPlayComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service) { }

    public examId: string = '';
    public exam: any = null;
    public questions: any[] = [];
    public currentIndex: number = 0;
    public loading: boolean = true;
    public submitting: boolean = false;

    // 타이머
    public timeLeft: number = 0;
    public timerInterval: any = null;
    public startTime: number = 0;

    // 각 문제별 소요시간 추적
    public questionStartTime: number = 0;

    public async ngOnInit() {
        await this.service.init();
        this.examId = WizRoute.segment.id || '';
        if (this.examId) await this.loadExam();
        await this.service.render();
    }

    ngOnDestroy() {
        if (this.timerInterval) clearInterval(this.timerInterval);
    }

    public async loadExam() {
        this.loading = true;
        let res = await wiz.call("load", { exam_id: this.examId });
        if (res.code === 200) {
            this.exam = res.data.exam;
            this.questions = res.data.questions || [];

            // 이전에 답한 곳부터 시작
            let firstUnanswered = this.questions.findIndex(q => !q.user_answer);
            this.currentIndex = firstUnanswered >= 0 ? firstUnanswered : 0;

            // 타이머 설정
            if (this.exam.time_limit > 0) {
                this.timeLeft = this.exam.time_limit;
                // 이미 경과된 시간 계산
                if (this.exam.started_at) {
                    const started = new Date(this.exam.started_at).getTime();
                    const elapsed = Math.floor((Date.now() - started) / 1000);
                    this.timeLeft = Math.max(0, this.exam.time_limit - elapsed);
                }
                this.startTimer();
            }

            this.startTime = Date.now();
            this.questionStartTime = Date.now();
        } else {
            await this.service.modal.error(res.data?.message || '시험을 불러올 수 없습니다');
            this.service.href('/quiz/setting');
        }
        this.loading = false;
        await this.service.render();
    }

    public startTimer() {
        this.timerInterval = setInterval(async () => {
            this.timeLeft--;
            if (this.timeLeft <= 0) {
                clearInterval(this.timerInterval);
                await this.service.modal.error('제한 시간이 초과되어 자동 제출됩니다.');
                await this.submitExam();
            }
            await this.service.render();
        }, 1000);
    }

    public get currentQuestion(): any {
        return this.questions[this.currentIndex] || null;
    }

    public get answeredCount(): number {
        return this.questions.filter(q => q.user_answer && q.user_answer.trim()).length;
    }

    public get progress(): number {
        return this.questions.length > 0 ? Math.round(this.answeredCount / this.questions.length * 100) : 0;
    }

    public formatTime(seconds: number): string {
        const m = Math.floor(seconds / 60);
        const s = seconds % 60;
        return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
    }

    // --- 이미지 문제 헬퍼 ---
    public get isImageQuestion(): boolean {
        return this.currentQuestion?.content?.startsWith('[IMG]') || false;
    }

    public get questionImageUrl(): string {
        if (!this.isImageQuestion) return '';
        const path = this.currentQuestion.content.substring(5);
        return wiz.url('question_image') + '?path=' + encodeURIComponent(path);
    }

    // --- 답안 선택 ---
    public async selectAnswer(answer: string) {
        if (!this.currentQuestion) return;
        this.currentQuestion.user_answer = answer;

        const timeSpent = Math.floor((Date.now() - this.questionStartTime) / 1000);
        await wiz.call("save", {
            exam_id: this.examId,
            question_id: this.currentQuestion.question_id,
            user_answer: answer,
            time_spent: String(timeSpent)
        });
        await this.service.render();
    }

    public async clearAnswer() {
        if (!this.currentQuestion) return;
        this.currentQuestion.user_answer = '';
        await wiz.call("save", {
            exam_id: this.examId,
            question_id: this.currentQuestion.question_id,
            user_answer: '',
            time_spent: '0'
        });
        await this.service.render();
    }

    // --- 네비게이션 ---
    public async goTo(idx: number) {
        if (idx < 0 || idx >= this.questions.length) return;
        this.currentIndex = idx;
        this.questionStartTime = Date.now();
        await this.service.render();
    }

    public async prev() {
        await this.goTo(this.currentIndex - 1);
    }

    public async next() {
        await this.goTo(this.currentIndex + 1);
    }

    // --- 제출 ---
    public async submitExam() {
        if (!this.submitting) {
            const unanswered = this.questions.length - this.answeredCount;
            if (unanswered > 0) {
                let confirm = await this.service.modal.show({
                    title: '제출 확인',
                    message: `${unanswered}문제가 미답 상태입니다. 제출하시겠습니까?`,
                    action: '예',
                    cancel: '아니오'
                });
                if (!confirm) return;
            } else {
                let confirm = await this.service.modal.show({
                    title: '제출 확인',
                    message: '시험을 제출하시겠습니까?',
                    action: '예',
                    cancel: '아니오'
                });
                if (!confirm) return;
            }
        }

        this.submitting = true;
        await this.service.render();

        if (this.timerInterval) clearInterval(this.timerInterval);

        let res = await wiz.call("finish", { exam_id: this.examId });
        if (res.code === 200) {
            this.service.href('/quiz/result/' + this.examId);
        } else {
            await this.service.modal.error(res.data?.message || '제출 실패');
            this.submitting = false;
            await this.service.render();
        }
    }

    public questionClass(idx: number): string {
        const q = this.questions[idx];
        if (idx === this.currentIndex) return 'bg-indigo-600 text-white';
        if (q?.user_answer) return 'bg-indigo-100 text-indigo-700';
        return 'bg-gray-100 text-gray-600 hover:bg-gray-200';
    }
}

export default PageQuizPlayComponent;